import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=bc61c49e&scoped=true&"
import script from "./echart.vue?vue&type=script&lang=ts&"
export * from "./echart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc61c49e",
  null
  
)

export default component.exports